import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import {useLocation} from "react-router-dom";
import { useCookies } from 'react-cookie';
import io from 'socket.io-client';
import API_HOST from '../../shared/utils/ApiHost.js';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { useFormik } from 'formik';
import * as yup from 'yup';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'© '}{new Date().getFullYear() + ' '}
      <Link color="inherit" href="https://mintmadness.app">
        Mint Madness
      </Link>{' '}
    </Typography>
  );
}

const validationSchema = yup.object({
  email: yup
    .string('Enter your email')
    .email('Enter a valid email')
    .required('Email is required'),
  password: yup
    .string('Enter your password')
    .min(8, 'Password should be of minimum 8 characters length')
    .matches(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/, {message: 'Password must contain a combination of numbers and upper/lowercase letters.'})
    .required('Password is required'),
  username: yup
    .string('Enter your team name')
    .max(15, 'Team name should be of maximum 15 characters length')
    .matches(/([a-zA-Z0-9-_.])/, {message: 'Team name should not contain special characters.'})
    .required('Team name is required'),
  group: yup
    .string('Enter your league name')
    .max(15, 'League name should be a maximum of 15 characters.')
    .matches(/([a-z0-9_])/, {message: 'League name should not contain special characters.'})
    .required('League name is required. Ask your league manage for the invite link.'),
  grouppass: yup
    .string('Enter your league password')
    .max(24, 'Incorrect league password.')
    .matches(/([a-z0-9_])/, {message: 'League password should not contain special characters.'})
    .required('League password is required. Ask your league manager for the invite link.'),
});


export default function Join() {
  const [userExists, setUserExists] = useState(false);
  const [userCreated, setUserCreated] = useState(false);
  const [cookies, setCookie] = useCookies(['room']);

  const search = useLocation().search;
  const group = new URLSearchParams(search).get('group');
  var cookieRoom = '';
  if(typeof group !== 'undefined' && group !== null && group !== '') {
    var duration = 60 * 60 * 24 * 5; // 5 days
    setCookie('room', group, { path: '/', maxAge: duration });
    cookieRoom = cookies.room;
  }

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      username: '',
      group: cookieRoom,
      grouppass: ''
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      var sendValues = JSON.stringify(values, null, 2);
      fetch(`${API_HOST}/api/join`,{
          method: 'post',
          headers: { 'Content-Type': 'application/json'},
          credentials: 'include',
          body: sendValues
      }).then(res=>res.json())
      .then(data=>{
        console.log(data)
        if(data.status === 'success') {
          var duration = 60 * 60 * 24 * 5; // 5 days
          localStorage.setItem('username',data.username)
          if(typeof data.room !== 'undefined' && data.room !== '') {
            setCookie('room', data.room, { path: '/', maxAge: duration });
            localStorage.setItem('room',data.room)
            localStorage.setItem('groupId',data.room)
            localStorage.setItem('teamId',data.teamId)
            const socket = io(API_HOST,{
              withCredentials: true,
              extraHeaders: {
                  "room": cookies.room
              }
            });
            socket.on("connected", data => {
              console.log(data)     
            });
          }

          setUserCreated(true)
        } else {
          if(data.message === 'User already exists') {
            setUserExists(true)
          }
        }
        
      })
      .catch(e=>{
        console.error(e)
        alert(e);
      })
    }
  });

  if(userCreated) {
    return <Redirect to="/login" />
  }
  return (
    <Container maxWidth="xs" className="form-container">
      <CssBaseline />
      <div className="form-wrapper"> 
        <div style={{textAlign: 'center'}}><img src="//mintconditioned.com/mintmadnessdraft/images/mint-madness-logo.svg" alt="Mint Madness" width="240" style={{height: 'auto', display: 'inline-block'}} /></div>

        <Typography component="h1" variant="h3">
          Join
        </Typography>
        {userExists &&
          <p className="warning-message">The team name and/or email address is already in use. Already have an account? <a href="/login">Sign in</a>.</p>
        }
        <form className="form form__user form__join" noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoFocus
                variant="outlined"
                required
                fullWidth
                type="email"
                id="email"
                label="Email Address"
                error={formik.touched.email && Boolean(formik.errors.email)}
                value={formik.values.email}
                onChange={formik.handleChange}
                name="email"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                minLength="8"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText="Minumum 8 characters. Combination of numbers and upper/lowercase letters required."
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="username"
                variant="outlined"
                required
                fullWidth
                id="username"
                label="Team Name"
                maxLength="15"
                value={formik.values.username}
                onChange={formik.handleChange}
                helperText="15 characters max"
                
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="group"
                variant="outlined"
                required
                fullWidth
                id="group"
                label="League Name"
                maxLength="15"
                value={formik.values.group}
                onChange={formik.handleChange}
                helperText="Your invite link will autofill the league name."
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="grouppass"
                variant="outlined"
                required
                fullWidth
                id="grouppass"
                label="League Password"
                maxLength="24"
                value={formik.values.grouppass}
                onChange={formik.handleChange}
                helperText="Ask your league manager for your password."
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className="form-submit"
          >
            Sign Up
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link href="/login" variant="body2" className="signin-login-link">
                Already have an account? Sign in
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container> 
  );
}